import React from "react";
import { Grid, Tooltip, Typography } from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { dateFormate } from "utils/utils";
import download from "assets/images/download.png";
import pdf from "assets/images/pdfImg.svg";
import CloudSyncOutlinedIcon from "@mui/icons-material/CloudSyncOutlined";
function CommonCardDetails({ data, handleOpen, onReuploadClick }) {
  const isExpired = (date) => {
  if (!date) return false;
  return new Date(date) < new Date();
};

const showReupload =
  data?.status === "Rejected" ||
  (data?.status === "Approved" && isExpired(data?.expiryDate));
  
  return (
    <>
      <Grid
        item
        md={3.6}
        sm={12}
        key={data?.id}
        className="borderStyle padding10 m10"
      >
        <div
          className={data?.complianceFile?.name.includes('.pdf') ? "dlPdf": "dlImgMain"}
          onClick={(e) => {
            if (e.target.tagName.toLowerCase() !== "input") {
              data?.attributeType !== "text" &&
              !data?.complianceFile?.name.includes(".pdf") &&
              handleOpen(data?.complianceFile?.url);
          }}}
        >
          <div className="dlImgBg"></div>
          <img
            src={ data?.complianceFile?.name.includes(".pdf")
            ? pdf
            : data?.complianceFile?.url}
            alt="driving"
            className="dlImg"
          />
        </div>

        <Grid item container direction="row" justifyContent="space-between">
          <Grid item>
            <h1 className="colorBlack font14 fontMedium">
              {data?.complianceName}
              {data?.isMandatory && <span className="colorRed">*</span>}
            </h1>
            {data?.number && (
              <p className="font12 fontNormal colorGrey">
                {"Number: " + data?.number}
              </p>
            )}

            {data?.expiryDate && (
              <p className="font12 fontNormal colorBlue">
                <span className="colorBlue">Exp&nbsp;</span>
                {dateFormate(data?.expiryDate, "DD MMMM YYYY")}
              </p>
            )}
          </Grid>
          <Grid item>
            <div className="colorGrey textCenter marginTop mb10">
              <span className="cursor">
                <a href={data?.complianceFile?.url} download={data?.name}>
                  <img src={download} alt="download icon" />
                </a>
              </span>
            </div>
          {data?.status && (
  <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
    
    <Tooltip title={data?.rejectionReason}>
      {data?.isExpired === true ? (
        <Typography className="colorRed flexDirection cursorDefault">
          Expired (
          <span className="text-sm text-gray-500">
            {data.status === "Rejected" && (
              <ErrorOutlineIcon className="marginRight3 font16" />
            )}
            {data?.status}
          </span>
          )
        </Typography>
      ) : (
        <Typography className={`${data?.status + "Btn"} flexDirection`}>
          {data.status === "Rejected" && (
            <ErrorOutlineIcon className="marginRight3 font16" />
          )}
          {data?.status}
        </Typography>
      )}
    </Tooltip>

    {showReupload && (
      <Tooltip title="Reupload">
        <CloudSyncOutlinedIcon
          className="cursor"
          style={{ color: "#2e7d32", fontSize: "20px" }}
          onClick={(e) => {
            e.stopPropagation();
            onReuploadClick(data);
          }}
        />
      </Tooltip>
    )}

  </div>
)}
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}

export default CommonCardDetails;
